import { demoFile, feature } from "system/demo";

demoFile('feature/admin/admin-mod-link', {});

feature('admin_link_mod', {
    structureKey: 'admin',
    instanceKey: 'demo',
    features: {
        admin_link_mod: true,
        admin_new_link_mod: true,
        admin_editorial_dash: true,
    }
});